import AddForm from "../components/Form/AddForm";
import { useGetProjectsQuery } from "../redux/features/projects/projectsApi";
import { useGetTeamQuery } from "../redux/features/Team/teamApi";


export default function AddTaskPage() {
  const { data: team, isLoading: teamLoading, isError: TeamError } = useGetTeamQuery();
  const { data: projects, isLoading, isError } = useGetProjectsQuery();

  let addForm = null;
  if(!isLoading && !teamLoading && !isError && !TeamError && team?.length > 0 && projects?.length > 0){
    addForm = <AddForm team={team} projects={projects} />
  }
  return <>
    {(isLoading || teamLoading) ? <div className="text-center">Loading...</div> : <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
          Create Task for Your Team
        </h1>
        <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
          {addForm}
        </div>
      </main>
    </div>}
  </>
};